import { VersionDependent, Versions } from '../types/VersionDependent';

import CBLogo from './CB/logo.svg';
import CKLogo from './CK/logo.svg';
import CBBELogo from './CBBE/logo.svg';
import GCUKLogo from './GCUK/logo.svg';
import GCSUKLogo from './GCSUK/logo.svg';
import CBDELogo from './CBDE/logo.svg';
import CBITLogo from './CBIT/logo.svg';
import CBIELogo from './CBIE/logo.svg';
import CBESLogo from './CBES/logo.svg';
import GCSDELogo from './GCSDE/logo.svg';
import GCSBELogo from './GCSBE/logo.svg';
import CBFRLogo from './CBFR/logo.svg'
import GCSFRLogo from './GCSFR/logo.svg';
import GCSNLLogo from './GCSNL/logo.svg';
import GCSITLogo from './GCSIT/logo.svg';
import GCSIELogo from './GCSIE/logo.svg';
import CBATLogo from './CBAT/logo.svg';
import GCSATLogo from './GCSAT/logo.svg';
import CKFRLogo from './CKFR/logo.svg'
import CBPLLogo from './CBPL/logo.svg';

import CBLogoV2 from './CB/logoV2.svg';
import CKLogoV2 from './CK/logoV2.svg';
import CBBELogoV2 from './CBBE/logoV2.svg';
import GCUKLogoV2 from './GCUK/logoV2.svg';
import GCSUKLogoV2 from './GCSUK/logoV2.svg';
import CBDELogoV2 from './CBDE/logoV2.svg';
import CBITLogoV2 from './CBIT/logoV2.svg';
import CBIELogoV2 from './CBIE/logoV2.svg';
import CBESLogoV2 from './CBES/logoV2.svg';
import GCSDELogoV2 from './GCSDE/logoV2.svg';
import GCSBELogoV2 from './GCSBE/logoV2.svg';
import CBFRLogoV2 from './CBFR/logoV2.svg'
import GCSFRLogoV2 from './GCSFR/logoV2.svg';
import GCSNLLogoV2 from './GCSNL/logoV2.svg';
import GCSITLogoV2 from './GCSIT/logoV2.svg';
import GCSIELogoV2 from './GCSIE/logoV2.svg';
import CBATLogoV2 from './CBAT/logoV2.svg';
import GCSATLogoV2 from './GCSAT/logoV2.svg';
import CKFRLogoV2 from './CKFR/logoV2.svg'
import CBPLLogoV2 from './CBPL/logoV2.svg';

import CBFooterLogo from './CB/footerLogo.svg';
import CKFooterLogo from './CK/footerLogo.svg';
import CBBEFooterLogo from './CBBE/footerLogo.svg';
import GCUKFooterLogo from './GCUK/footerLogo.svg';
import GCSUKFooterLogo from './GCSUK/footerLogo.svg';
import CBDEFooterLogo from './CBDE/footerLogo.svg';
import CBITFooterLogo from './CBIT/footerLogo.svg';
import CBIEFooterLogo from './CBIE/footerLogo.svg';
import CBESFooterLogo from './CBES/footerLogo.svg';
import GCSDEFooterLogo from './GCSDE/footerLogo.svg';
import GCSBEFooterLogo from './GCSBE/footerLogo.svg';
import CBFRFooterLogo from './CBFR/footerLogo.svg';
import GCSFRFooterLogo from './GCSFR/footerLogo.svg';
import GCSNLFooterLogo from './GCSNL/footerLogo.svg';
import GCSITFooterLogo from './GCSIT/footerLogo.svg';
import GCSIEFooterLogo from './GCSIE/footerLogo.svg';
import CBATFooterLogo from './CBAT/footerLogo.svg';
import GCSATFooterLogo from './GCSAT/footerLogo.svg';
import CKFRFooterLogo from './CKFR/footerLogo.svg';
import CBPLFooterLogo from './CBPL/footerLogo.svg';

import CBPDPFeaturedBlock from './CB/pdpFeaturedBlock.webp';
import CKPDPFeaturedBlock from './CK/pdpFeaturedBlock.webp';
import CBBEPDPFeaturedBlock from './CBBE/pdpFeaturedBlock.webp';
import GCUKPDPFeaturedBlock from './GCUK/pdpFeaturedBlock.webp';
import GCSUKPDPFeaturedBlock from './GCSUK/pdpFeaturedBlock.svg';
import CBDEPDPFeaturedBlock from './CBDE/pdpFeaturedBlock.webp';
import CBITPDPFeaturedBlock from './CBIT/pdpFeaturedBlock.webp';
import CBIEPDPFeaturedBlock from './CBIE/pdpFeaturedBlock.webp';
import CBESPDPFeaturedBlock from './CBES/pdpFeaturedBlock.webp';
import GCSDEPDPFeaturedBlock from './GCSDE/pdpFeaturedBlock.svg';
import GCSBEPDPFeaturedBlock from './GCSBE/pdpFeaturedBlock.webp';
import CBFRPDPFeaturedBlock from './CBFR/pdpFeaturedBlock.webp';
import GCSFRPDPFeaturedBlock from './GCSFR/pdpFeaturedBlock.webp';
import GCSNLPDPFeaturedBlock from './GCSNL/pdpFeaturedBlock.webp';
import GCSITPDPFeaturedBlock from './GCSIT/pdpFeaturedBlock.webp';
import GCSIEPDPFeaturedBlock from './GCSIE/pdpFeaturedBlock.webp';
import CBATPDPFeaturedBlock from './CBAT/pdpFeaturedBlock.webp';
import GCSATPDPFeaturedBlock from './GCSAT/pdpFeaturedBlock.webp';
import CKFRPDPFeaturedBlock from './CK/pdpFeaturedBlock.webp';
import CBPLPDPFeaturedBlock from './CBPL/pdpFeaturedBlock.webp';

import CBModalLogo from './CB/modalLogo.svg';
import CKModalLogo from './CK/modalLogo.svg';
import CBBEModalLogo from './CBBE/modalLogo.svg';
import GCUKModalLogo from './GCUK/modalLogo.svg';
import GCSUKModalLogo from './GCSUK/modalLogo.svg';
import CBDEModalLogo from './CBDE/modalLogo.svg';
import CBITModalLogo from './CBIT/modalLogo.svg';
import CBIEModalLogo from './CBIE/modalLogo.svg';
import CBESModalLogo from './CBES/modalLogo.svg';
import GCSDEModalLogo from './GCSDE/modalLogo.svg';
import GCSBEModalLogo from './GCSBE/modalLogo.svg';
import CBFRModalLogo from './CBFR/modalLogo.svg';
import GCSFRModalLogo from './GCSFR/modalLogo.svg';
import GCSNLModalLogo from './GCSNL/modalLogo.svg';
import GCSITModalLogo from './GCSIT/modalLogo.svg';
import GCSIEModalLogo from './GCSIE/modalLogo.svg';
import CBATModalLogo from './CBAT/modalLogo.svg';
import GCSATModalLogo from './GCSAT/modalLogo.svg';
import CKFRModalLogo from './CK/modalLogo.svg';
import CBPLModalLogo from './CBPL/modalLogo.svg';

import thuiswinkelTrustmark from './trustmarks/thuiswinkel.svg';
import GCVALogo from './trustmarks/GCVA_zwart.svg';
import IMAeuropeLogo from './trustmarks/IMAeurope_zwart.png';
import GCVALogoWhite from './trustmarks/GCVA_zwart_white.svg';
import IMAeuropeLogoWhite from './trustmarks/IMAeurope_zwart_white.svg';

import CBNotFoundImage from './404/404-cb-poppetje.svg';
import CKNotFoundImage from './404/404-ck.webp';
import GCSUKNotFoundImage from './404/GCSUK-404.svg';
import GCSDENotFoundImage from './404/GCSDE-404.svg';
import GCSFRNotFoundImage from './404/GCSFR-404.svg';
import GCSNLNotFoundImage from './404/GCSNL-404.svg';
import CBATNotFoundImage from './404/CBAT-404.svg';
import GCSATNotFoundImage from './404/GCSAT-404.svg';

import promotionalBlock from './pdp/promotion_block.webp';
import promotionalBlockPounds from './pdp/promotion_block_pounds.webp';
import promotionalBlockCBDE from './CBDE/promotionalBlock.webp';
import promotionalBlockGCSDE from './GCSDE/promotionalBlock.webp';

import fagImage from './faq-bg-image/faq-bg-image.webp';
import GCSUKFagImage from './GCSUK/faq-bg-image.webp';
import GCSDEFagImage from './GCSDE/faq-bg-image.webp';
import GCSBEFagImage from './GCSBE/faq-bg-image.webp';
import GCSFRFagImage from './GCSFR/faq-bg-image.webp';
import GCSNLFagImage from './GCSNL/faq-bg-image.webp';
import CBATFagImage from './GCSNL/faq-bg-image.webp';
import GCSATFagImage from './GCSAT/faq-bg-image.webp';

import doublerImage from './doubler-modal/doubler-modal-card.webp';
import GCSUKDoublerImage from './GCSUK/doubler-modal-card.webp';
import GCSDEDoublerImage from './GCSDE/doubler-modal-card.webp';
import GCSBEDoublerImage from './GCSBE/doubler-modal-card.webp';
import GCSFRDoublerImage from './GCSFR/doubler-modal-card.webp';
import GCSNLDoublerImage from './GCSNL/doubler-modal-card.webp';
import CBATDoublerImage from './CBAT/doubler-modal-card.webp';
import GCSATDoublerImage from './GCSAT/doubler-modal-card.webp';

import footerClockIcon from './footer/clock.svg';
import GCSUKFooterClockIcon from './GCSUK/footerClockIcon.svg';
import GCSDEFooterClockIcon from './GCSDE/footerClockIcon.svg';
import GCSBEFooterClockIcon from './GCSBE/footerClockIcon.svg';
import GCSFRFooterClockIcon from './GCSFR/footerClockIcon.svg';
import GCSNLFooterClockIcon from './GCSNL/footerClockIcon.svg';
import CBATFooterClockIcon from './CBAT/footerClockIcon.svg';
import GCSATFooterClockIcon from './GCSAT/footerClockIcon.svg';

import DoublerPageBG from './background/doubler-page-bg.webp';
import DoublerHeroCardImage from './doubler-hero/doubler-hero-card.webp';
import CKDoublerPageBG from './background/CK-doubler-page-bg.webp';
import CKDoublerHeroCardImage from './doubler-hero/CK-doubler-hero-card.webp';
import { PaymentLogo } from '../types/PaymentLogos';

import CBAlternativeChoiceAllInOne from './CB/alternativeChoiceAllInOne.webp';
import CBATAlternativeChoiceAllInOne from './CBAT/alternativeChoiceAllInOne.webp';
import CBBEAlternativeChoiceAllInOne from './CBBE/alternativeChoiceAllInOne.webp';
import CBDEAlternativeChoiceAllInOne from './CBDE/alternativeChoiceAllInOne.webp';
import CBFRAlternativeChoiceAllInOne from './CBFR/alternativeChoiceAllInOne.webp';
import CBIEAlternativeChoiceAllInOne from './CBIE/alternativeChoiceAllInOne.webp';
import CBESAlternativeChoiceAllInOne from './CBES/alternativeChoiceAllInOne.webp';
import CBITAlternativeChoiceAllInOne from './CBIT/alternativeChoiceAllInOne.webp';
import CKAlternativeChoiceAllInOne from './CK/alternativeChoiceAllInOne.webp';
import CKFRAlternativeChoiceAllInOne from './CKFR/alternativeChoiceAllInOne.webp';
import GCSATAlternativeChoiceAllInOne from './GCSAT/alternativeChoiceAllInOne.webp';
import GCSDEAlternativeChoiceAllInOne from './GCSDE/alternativeChoiceAllInOne.webp';
import GCSBEAlternativeChoiceAllInOne from './GCSBE/alternativeChoiceAllInOne.webp';
import GCSFRAlternativeChoiceAllInOne from './GCSFR/alternativeChoiceAllInOne.webp';
import GCSIEAlternativeChoiceAllInOne from './GCSIE/alternativeChoiceAllInOne.webp';
import GCSITAlternativeChoiceAllInOne from './GCSIT/alternativeChoiceAllInOne.webp';
import GCSNLAlternativeChoiceAllInOne from './GCSNL/alternativeChoiceAllInOne.webp';
import GCSUKAlternativeChoiceAllInOne from './GCSUK/alternativeChoiceAllInOne.webp';
import GCUKAlternativeChoiceAllInOne from './GCUK/alternativeChoiceAllInOne.webp';
import CBPLAlternativeChoiceAllInOne from './CBPL/alternativeChoiceAllInOne.webp';

import CBPdpBusinessLogo from './CB/pdpBusinessLogo.svg';
import CBEnPdpBusinessLogo from './CB/pdpBusinessLogoEn.svg';
import CBATPdpBusinessLogo from './CBAT/pdpBusinessLogo.svg';
import CBBEPdpBusinessLogo from './CBBE/pdpBusinessLogo.svg';
import CBBEFrPdpBusinessLogo from './CBBE/pdpBusinessLogoFr.svg';
import CBDEPdpBusinessLogo from './CBDE/pdpBusinessLogo.svg';
import CBFRPdpBusinessLogo from './CBFR/pdpBusinessLogo.svg';
import CBIEPdpBusinessLogo from './CBIE/pdpBusinessLogo.svg';
import CBESPdpBusinessLogo from './CBES/pdpBusinessLogo.svg';
import CBITPdpBusinessLogo from './CBIT/pdpBusinessLogo.svg';
import CKPdpBusinessLogo from './CK/pdpBusinessLogo.svg';
import CKFRPdpBusinessLogo from './CKFR/pdpBusinessLogo.svg';
import GCSATPdpBusinessLogo from './GCSAT/pdpBusinessLogo.svg';
import GCSDEPdpBusinessLogo from './GCSDE/pdpBusinessLogo.svg';
import GCSBEPdpBusinessLogo from './GCSBE/pdpBusinessLogo.svg';
import GCSFRPdpBusinessLogo from './GCSFR/pdpBusinessLogo.svg';
import GCSIEPdpBusinessLogo from './GCSIE/pdpBusinessLogo.svg';
import GCSITPdpBusinessLogo from './GCSIT/pdpBusinessLogo.svg';
import GCSNLPdpBusinessLogo from './GCSNL/pdpBusinessLogo.svg';
import GCSUKPdpBusinessLogo from './GCSUK/pdpBusinessLogo.svg';
import GCUKPdpBusinessLogo from './GCUK/pdpBusinessLogo.svg';
import CBPLPdpBusinessLogo from './CBPL/pdpBusinessLogo.svg';

import CBPdpBusinessLogoMobile from './CB/pdpBusinessLogoMobile.svg';
import CBEnPdpBusinessLogoMobile from './CB/pdpBusinessLogoMobileEn.svg';
import CBATPdpBusinessLogoMobile from './CBAT/pdpBusinessLogoMobile.svg';
import CBBEPdpBusinessLogoMobile from './CBBE/pdpBusinessLogoMobile.svg';
import CBBEFrPdpBusinessLogoMobile from './CBBE/pdpBusinessLogoMobileFr.svg';
import CBDEPdpBusinessLogoMobile from './CBDE/pdpBusinessLogoMobile.svg';
import CBFRPdpBusinessLogoMobile from './CBFR/pdpBusinessLogoMobile.svg';
import CBIEPdpBusinessLogoMobile from './CBIE/pdpBusinessLogoMobile.svg';
import CBESPdpBusinessLogoMobile from './CBES/pdpBusinessLogoMobile.svg';
import CBITPdpBusinessLogoMobile from './CBIT/pdpBusinessLogoMobile.svg';
import CKPdpBusinessLogoMobile from './CK/pdpBusinessLogoMobile.svg';
import CKFRPdpBusinessLogoMobile from './CKFR/pdpBusinessLogoMobile.svg';
import GCSATPdpBusinessLogoMobile from './GCSAT/pdpBusinessLogoMobile.svg';
import GCSDEPdpBusinessLogoMobile from './GCSDE/pdpBusinessLogoMobile.svg';
import GCSBEPdpBusinessLogoMobile from './GCSBE/pdpBusinessLogoMobile.svg';
import GCSFRPdpBusinessLogoMobile from './GCSFR/pdpBusinessLogoMobile.svg';
import GCSIEPdpBusinessLogoMobile from './GCSIE/pdpBusinessLogoMobile.svg';
import GCSITPdpBusinessLogoMobile from './GCSIT/pdpBusinessLogoMobile.svg';
import GCSNLPdpBusinessLogoMobile from './GCSNL/pdpBusinessLogoMobile.svg';
import GCSUKPdpBusinessLogoMobile from './GCSUK/pdpBusinessLogoMobile.svg';
import GCUKPdpBusinessLogoMobile from './GCUK/pdpBusinessLogoMobile.svg';
import CBPLPdpBusinessLogoMobile from './CBPL/pdpBusinessLogoMobile.svg';
import CBNZAlternativeChoiceAllInOne from './CBNZ/alternativeChoiceAllInOne.webp';
import CBNZFooterLogo from './CBNZ/footerLogo.svg';
import CBNZLogo from './CBNZ/logo.svg';
import CBNZLogoV2 from './CBNZ/logoV2.svg';
import CBNZModalLogo from './CBNZ/modalLogo.svg';
import CBNZPdpBusinessLogo from './CBNZ/pdpBusinessLogo.svg';
import CBNZPdpBusinessLogoMobile from './CBNZ/pdpBusinessLogoMobile.svg';
import CBNZPDPFeaturedBlock from './CBNZ/pdpFeaturedBlock.webp';
import CBSEAlternativeChoiceAllInOne from './CBSE/alternativeChoiceAllInOne.webp';
import CBSEFooterLogo from './CBSE/footerLogo.svg';
import CBSELogo from './CBSE/logo.svg';
import CBSELogoV2 from './CBSE/logoV2.svg';
import CBSEModalLogo from './CBSE/modalLogo.svg';
import CBSEPdpBusinessLogo from './CBSE/pdpBusinessLogo.svg';
import CBSEPdpBusinessLogoMobile from './CBSE/pdpBusinessLogoMobile.svg';
import CBSEPDPFeaturedBlock from './CBSE/pdpFeaturedBlock.webp';
import CBMXAlternativeChoiceAllInOne from './CBMX/alternativeChoiceAllInOne.webp';
import CBMXFooterLogo from './CBMX/footerLogo.svg';
import CBMXLogo from './CBMX/logo.svg';
import CBMXLogoV2 from './CBMX/logoV2.svg';
import CBMXModalLogo from './CBMX/modalLogo.svg';
import CBMXPdpBusinessLogo from './CBMX/pdpBusinessLogo.svg';
import CBMXPdpBusinessLogoMobile from './CBMX/pdpBusinessLogoMobile.svg';
import CBMXPDPFeaturedBlock from './CBMX/pdpFeaturedBlock.webp';
import CBNOAlternativeChoiceAllInOne from './CBNO/alternativeChoiceAllInOne.webp';
import CBNOFooterLogo from './CBNO/footerLogo.svg';
import CBNOLogo from './CBNO/logo.svg';
import CBNOLogoV2 from './CBNO/logoV2.svg';
import CBNOModalLogo from './CBNO/modalLogo.svg';
import CBNOPdpBusinessLogo from './CBNO/pdpBusinessLogo.svg';
import CBNOPdpBusinessLogoMobile from './CBNO/pdpBusinessLogoMobile.svg';
import CBNOPDPFeaturedBlock from './CBNO/pdpFeaturedBlock.webp';
import CBDKAlternativeChoiceAllInOne from './CBDK/alternativeChoiceAllInOne.webp';
import CBDKFooterLogo from './CBDK/footerLogo.svg';
import CBDKLogo from './CBDK/logo.svg';
import CBDKLogoV2 from './CBDK/logoV2.svg';
import CBDKModalLogo from './CBDK/modalLogo.svg';
import CBDKPdpBusinessLogo from './CBDK/pdpBusinessLogo.svg';
import CBDKPdpBusinessLogoMobile from './CBDK/pdpBusinessLogoMobile.svg';
import CBDKPDPFeaturedBlock from './CBDK/pdpFeaturedBlock.webp';
import CKUKAlternativeChoiceAllInOne from './CKUK/alternativeChoiceAllInOne.webp';
import CKUKFooterLogo from './CKUK/footerLogo.svg';
import CKUKLogo from './CKUK/logo.svg';
import CKUKLogoV2 from './CKUK/logoV2.svg';
import CKUKModalLogo from './CKUK/modalLogo.svg';
import CKUKPdpBusinessLogo from './CKUK/pdpBusinessLogo.svg';
import CKUKPdpBusinessLogoMobile from './CKUK/pdpBusinessLogoMobile.svg';
import CKUKPDPFeaturedBlock from './CKUK/pdpFeaturedBlock.webp';
import CBAUAlternativeChoiceAllInOne from './CBAU/alternativeChoiceAllInOne.webp';
import CBAUFooterLogo from './CBAU/footerLogo.svg';
import CBAULogo from './CBAU/logo.svg';
import CBAULogoV2 from './CBAU/logoV2.svg';
import CBAUModalLogo from './CBAU/modalLogo.svg';
import CBAUPdpBusinessLogo from './CBAU/pdpBusinessLogo.svg';
import CBAUPdpBusinessLogoMobile from './CBAU/pdpBusinessLogoMobile.svg';
import CBAUPDPFeaturedBlock from './CBAU/pdpFeaturedBlock.webp';
import CBBRAlternativeChoiceAllInOne from './CBBR/alternativeChoiceAllInOne.webp';
import CBBRFooterLogo from './CBBR/footerLogo.svg';
import CBBRLogo from './CBBR/logo.svg';
import CBBRLogoV2 from './CBBR/logoV2.svg';
import CBBRModalLogo from './CBBR/modalLogo.svg';
import CBBRPdpBusinessLogo from './CBBR/pdpBusinessLogo.svg';
import CBBRPdpBusinessLogoMobile from './CBBR/pdpBusinessLogoMobile.svg';
import CBBRPDPFeaturedBlock from './CBBR/pdpFeaturedBlock.webp';
import GCSPTAlternativeChoiceAllInOne from './GCSPT/alternativeChoiceAllInOne.webp';
import GCSPTFooterLogo from './GCSPT/footerLogo.svg';
import GCSPTLogo from './GCSPT/logo.svg';
import GCSPTLogoV2 from './GCSPT/logoV2.svg';
import GCSPTModalLogo from './GCSPT/modalLogo.svg';
import GCSPTPdpBusinessLogo from './GCSPT/pdpBusinessLogo.svg';
import GCSPTPdpBusinessLogoMobile from './GCSPT/pdpBusinessLogoMobile.svg';
import GCSPTPDPFeaturedBlock from './GCSPT/pdpFeaturedBlock.webp';

const GCSPT: VersionDependent = {
  logo: {
    src: GCSPTLogo,
  },
  logoV2: {
    src: GCSPTLogoV2,
  },
  footerClockIcon: {
    src: footerClockIcon,
  },
  footerLogo: {
    src: GCSPTFooterLogo,
  },
  modalLogo: {
    src: GCSPTModalLogo,
  },
  pdpFeaturedBlock: {
    src: GCSPTPDPFeaturedBlock,
    link: 'https://example-link.com',
  },
  pdpPromotionBlock: {
    src: promotionalBlock,
  },
  trustMarks: [],
  trustMarksTopbar: [],
  notFoundImage: {
    src: CBNotFoundImage,
    width: 200,
  },
  headerDecoration: null,
  footerDecoration: null,
  faq: {
    src: fagImage,
  },
  doubler: {
    src: doublerImage,
  },
  doublerPageBg: {
    src: DoublerPageBG,
  },
  doublerHeroCardImage: {
    src: DoublerHeroCardImage,
  },
  paymentLogos: [
    PaymentLogo.Mastercard,
    PaymentLogo.Visa,
    PaymentLogo.Amex,
  ],
  alternativeChoiceAllInOne: GCSPTAlternativeChoiceAllInOne,
  pdpBusinessLogo: {
    [CONFIG.defaultLocale]: GCSPTPdpBusinessLogo,
  },
  mobilePdpBusinessLogo: {
    [CONFIG.defaultLocale]: GCSPTPdpBusinessLogoMobile,
  },
  organizationStructuredData: null,
};

const CBBR: VersionDependent = {
  logo: {
    src: CBBRLogo,
  },
  logoV2: {
    src: CBBRLogoV2,
  },
  footerClockIcon: {
    src: footerClockIcon,
  },
  footerLogo: {
    src: CBBRFooterLogo,
  },
  modalLogo: {
    src: CBBRModalLogo,
  },
  pdpFeaturedBlock: {
    src: CBBRPDPFeaturedBlock,
    link: 'https://example-link.com',
  },
  pdpPromotionBlock: {
    src: promotionalBlock,
  },
  trustMarks: [],
  trustMarksTopbar: [],
  notFoundImage: {
    src: CBNotFoundImage,
    width: 200,
  },
  headerDecoration: null,
  footerDecoration: null,
  faq: {
    src: fagImage,
  },
  doubler: {
    src: doublerImage,
  },
  doublerPageBg: {
    src: DoublerPageBG,
  },
  doublerHeroCardImage: {
    src: DoublerHeroCardImage,
  },
  paymentLogos: [
    PaymentLogo.Mastercard,
    PaymentLogo.Visa,
    PaymentLogo.Amex,
  ],
  alternativeChoiceAllInOne: CBBRAlternativeChoiceAllInOne,
  pdpBusinessLogo: {
    [CONFIG.defaultLocale]: CBBRPdpBusinessLogo,
  },
  mobilePdpBusinessLogo: {
    [CONFIG.defaultLocale]: CBBRPdpBusinessLogoMobile,
  },
  organizationStructuredData: null,
};

const CBAU: VersionDependent = {
  logo: {
    src: CBAULogo,
  },
  logoV2: {
    src: CBAULogoV2,
  },
  footerClockIcon: {
    src: footerClockIcon,
  },
  footerLogo: {
    src: CBAUFooterLogo,
  },
  modalLogo: {
    src: CBAUModalLogo,
  },
  pdpFeaturedBlock: {
    src: CBAUPDPFeaturedBlock,
    link: 'https://example-link.com',
  },
  pdpPromotionBlock: {
    src: promotionalBlock,
  },
  trustMarks: [],
  trustMarksTopbar: [],
  notFoundImage: {
    src: CBNotFoundImage,
    width: 200,
  },
  headerDecoration: null,
  footerDecoration: null,
  faq: {
    src: fagImage,
  },
  doubler: {
    src: doublerImage,
  },
  doublerPageBg: {
    src: DoublerPageBG,
  },
  doublerHeroCardImage: {
    src: DoublerHeroCardImage,
  },
  paymentLogos: [
    PaymentLogo.Mastercard,
    PaymentLogo.Visa,
    PaymentLogo.Amex,
  ],
  alternativeChoiceAllInOne: CBAUAlternativeChoiceAllInOne,
  pdpBusinessLogo: {
    [CONFIG.defaultLocale]: CBAUPdpBusinessLogo,
  },
  mobilePdpBusinessLogo: {
    [CONFIG.defaultLocale]: CBAUPdpBusinessLogoMobile,
  },
  organizationStructuredData: null,
};

const CKUK: VersionDependent = {
  logo: {
    src: CKUKLogo,
  },
  logoV2: {
    src: CKUKLogoV2,
  },
  footerClockIcon: {
    src: footerClockIcon,
  },
  footerLogo: {
    src: CKUKFooterLogo,
  },
  modalLogo: {
    src: CKUKModalLogo,
  },
  pdpFeaturedBlock: {
    src: CKUKPDPFeaturedBlock,
    link: '/voucher/choice-gift/',
  },
  pdpPromotionBlock: {
    src: promotionalBlock,
  },
  trustMarks: [
    {
      src: GCVALogo,
    },
    {
      src: IMAeuropeLogo,
    }
  ],
  trustMarksTopbar: [],
  notFoundImage: {
    src: CBNotFoundImage,
    width: 200,
  },
  headerDecoration: null,
  footerDecoration: null,
  faq: {
    src: fagImage,
  },
  doubler: {
    src: doublerImage,
  },
  doublerPageBg: {
    src: DoublerPageBG,
  },
  doublerHeroCardImage: {
    src: DoublerHeroCardImage,
  },
  paymentLogos: [
    PaymentLogo.Mastercard,
    PaymentLogo.Visa,
    PaymentLogo.Amex,
  ],
  alternativeChoiceAllInOne: CKUKAlternativeChoiceAllInOne,
  pdpBusinessLogo: {
    [CONFIG.defaultLocale]: CKUKPdpBusinessLogo,
  },
  mobilePdpBusinessLogo: {
    [CONFIG.defaultLocale]: CKUKPdpBusinessLogoMobile,
  },
  organizationStructuredData: null,
};

const CBMX: VersionDependent = {
  logo: {
    src: CBMXLogo,
  },
  logoV2: {
    src: CBMXLogoV2,
  },
  footerClockIcon: {
    src: footerClockIcon,
  },
  footerLogo: {
    src: CBMXFooterLogo,
  },
  modalLogo: {
    src: CBMXModalLogo,
  },
  pdpFeaturedBlock: {
    src: CBMXPDPFeaturedBlock,
    link: 'https://example-link.com',
  },
  pdpPromotionBlock: {
    src: promotionalBlock,
  },
  trustMarks: [],
  trustMarksTopbar: [],
  notFoundImage: {
    src: CBNotFoundImage,
    width: 200,
  },
  headerDecoration: null,
  footerDecoration: null,
  faq: {
    src: fagImage,
  },
  doubler: {
    src: doublerImage,
  },
  doublerPageBg: {
    src: DoublerPageBG,
  },
  doublerHeroCardImage: {
    src: DoublerHeroCardImage,
  },
  paymentLogos: [
    PaymentLogo.Mastercard,
    PaymentLogo.Visa,
    PaymentLogo.Amex,
  ],
  alternativeChoiceAllInOne: CBMXAlternativeChoiceAllInOne,
  pdpBusinessLogo: {
    [CONFIG.defaultLocale]: CBMXPdpBusinessLogo,
  },
  mobilePdpBusinessLogo: {
    [CONFIG.defaultLocale]: CBMXPdpBusinessLogoMobile,
  },
  organizationStructuredData: null
};

const CBSE: VersionDependent = {
  logo: {
    src: CBSELogo,
  },
  logoV2: {
    src: CBSELogoV2,
  },
  footerClockIcon: {
    src: footerClockIcon,
  },
  footerLogo: {
    src: CBSEFooterLogo,
  },
  modalLogo: {
    src: CBSEModalLogo,
  },
  pdpFeaturedBlock: {
    src: CBSEPDPFeaturedBlock,
    link: '/presentkort/allt-i-ett/',
  },
  pdpPromotionBlock: {
    src: promotionalBlock,
  },
  trustMarks: [],
  trustMarksTopbar: [],
  notFoundImage: {
    src: CBNotFoundImage,
    width: 200,
  },
  headerDecoration: null,
  footerDecoration: null,
  faq: {
    src: fagImage,
  },
  doubler: {
    src: doublerImage,
  },
  doublerPageBg: {
    src: DoublerPageBG,
  },
  doublerHeroCardImage: {
    src: DoublerHeroCardImage,
  },
  paymentLogos: [
    PaymentLogo.Mastercard,
    PaymentLogo.Visa,
    PaymentLogo.Amex,
  ],
  alternativeChoiceAllInOne: CBSEAlternativeChoiceAllInOne,
  pdpBusinessLogo: {
    [CONFIG.defaultLocale]: CBSEPdpBusinessLogo,
  },
  mobilePdpBusinessLogo: {
    [CONFIG.defaultLocale]: CBSEPdpBusinessLogoMobile,
  },
  organizationStructuredData: null,
};

const CBDK: VersionDependent = {
  logo: {
    src: CBDKLogo,
  },
  logoV2: {
    src: CBDKLogoV2,
  },
  footerClockIcon: {
    src: footerClockIcon,
  },
  footerLogo: {
    src: CBDKFooterLogo,
  },
  modalLogo: {
    src: CBDKModalLogo,
  },
  pdpFeaturedBlock: {
    src: CBDKPDPFeaturedBlock,
    link: 'https://example-link.com',
  },
  pdpPromotionBlock: {
    src: promotionalBlock,
  },
  trustMarks: [],
  trustMarksTopbar: [],
  notFoundImage: {
    src: CBNotFoundImage,
    width: 200,
  },
  headerDecoration: null,
  footerDecoration: null,
  faq: {
    src: fagImage,
  },
  doubler: {
    src: doublerImage,
  },
  doublerPageBg: {
    src: DoublerPageBG,
  },
  doublerHeroCardImage: {
    src: DoublerHeroCardImage,
  },
  paymentLogos: [
    PaymentLogo.Mastercard,
    PaymentLogo.Visa,
    PaymentLogo.Amex,
  ],
  alternativeChoiceAllInOne: CBDKAlternativeChoiceAllInOne,
  pdpBusinessLogo: {
    [CONFIG.defaultLocale]: CBDKPdpBusinessLogo,
  },
  mobilePdpBusinessLogo: {
    [CONFIG.defaultLocale]: CBDKPdpBusinessLogoMobile,
  },
  organizationStructuredData: null,
};

const CBNO: VersionDependent = {
  logo: {
    src: CBNOLogo,
  },
  logoV2: {
    src: CBNOLogoV2,
  },
  footerClockIcon: {
    src: footerClockIcon,
  },
  footerLogo: {
    src: CBNOFooterLogo,
  },
  modalLogo: {
    src: CBNOModalLogo,
  },
  pdpFeaturedBlock: {
    src: CBNOPDPFeaturedBlock,
    link: 'https://example-link.com',
  },
  pdpPromotionBlock: {
    src: promotionalBlock,
  },
  trustMarks: [],
  trustMarksTopbar: [],
  notFoundImage: {
    src: CBNotFoundImage,
    width: 200,
  },
  headerDecoration: null,
  footerDecoration: null,
  faq: {
    src: fagImage,
  },
  doubler: {
    src: doublerImage,
  },
  doublerPageBg: {
    src: DoublerPageBG,
  },
  doublerHeroCardImage: {
    src: DoublerHeroCardImage,
  },
  paymentLogos: [
    PaymentLogo.Mastercard,
    PaymentLogo.Visa,
    PaymentLogo.Amex,
  ],
  alternativeChoiceAllInOne: CBNOAlternativeChoiceAllInOne,
  pdpBusinessLogo: {
    [CONFIG.defaultLocale]: CBNOPdpBusinessLogo,
  },
  mobilePdpBusinessLogo: {
    [CONFIG.defaultLocale]: CBNOPdpBusinessLogoMobile,
  },
  organizationStructuredData: null,
};

const CBNZ: VersionDependent = {
  logo: {
    src: CBNZLogo,
  },
  logoV2: {
    src: CBNZLogoV2,
  },
  footerClockIcon: {
    src: footerClockIcon,
  },
  footerLogo: {
    src: CBNZFooterLogo,
  },
  modalLogo: {
    src: CBNZModalLogo,
  },
  pdpFeaturedBlock: {
    src: CBNZPDPFeaturedBlock,
    link: '/gift-cards/all-in-1-choice/',
  },
  pdpPromotionBlock: {
    src: promotionalBlock,
  },
  trustMarks: [],
  trustMarksTopbar: [],
  notFoundImage: {
    src: CBNotFoundImage,
    width: 200,
  },
  headerDecoration: null,
  footerDecoration: null,
  faq: {
    src: fagImage,
  },
  doubler: {
    src: doublerImage,
  },
  doublerPageBg: {
    src: DoublerPageBG,
  },
  doublerHeroCardImage: {
    src: DoublerHeroCardImage,
  },
  paymentLogos: [
    PaymentLogo.Mastercard,
    PaymentLogo.Visa,
    PaymentLogo.Amex,
  ],
  alternativeChoiceAllInOne: CBNZAlternativeChoiceAllInOne,
  pdpBusinessLogo: {
    [CONFIG.defaultLocale]: CBNZPdpBusinessLogo,
  },
  mobilePdpBusinessLogo: {
    [CONFIG.defaultLocale]: CBNZPdpBusinessLogoMobile,
  },
  organizationStructuredData: null,
};


const CB: VersionDependent = {
  logo: {
    src: CBLogo,
  },
  logoV2: {
    src: CBLogoV2,
  },
  footerClockIcon: {
    src: footerClockIcon,
  },
  footerLogo: {
    src: CBFooterLogo,
  },
  modalLogo: {
    src: CBModalLogo,
  },
  pdpFeaturedBlock: {
    src: CBPDPFeaturedBlock,
    link: 'https://www.cadeaubon.nl/cadeaubonnen/cadeaubonnl-keuze-cadeaukaart/',
  },
  pdpPromotionBlock: {
    src: promotionalBlock,
  },
  trustMarks: [],
  trustMarksTopbar: [{
    src: thuiswinkelTrustmark,
    link: 'https://www.thuiswinkel.org/leden/cadeaubon-nl/certificaat/',
    width: 120,
  }],
  notFoundImage: {
    src: CBNotFoundImage,
    width: 200,
  },
  headerDecoration: null,
  footerDecoration: null,
  faq: {
    src: fagImage,
  },
  doubler: {
    src: doublerImage,
  },
  doublerPageBg: {
    src: DoublerPageBG,
  },
  doublerHeroCardImage: {
    src: DoublerHeroCardImage,
  },
  paymentLogos: [
    PaymentLogo.Secure,
    PaymentLogo.Ideal,
    PaymentLogo.Mastercard,
    PaymentLogo.Visa,
    PaymentLogo.Invoice,
  ],
  alternativeChoiceAllInOne: CBAlternativeChoiceAllInOne,
  pdpBusinessLogo: {
    [CONFIG.defaultLocale]: CBPdpBusinessLogo,
    'en-nl': CBEnPdpBusinessLogo,
  },
  mobilePdpBusinessLogo: {
    [CONFIG.defaultLocale]: CBPdpBusinessLogoMobile,
    'en-nl': CBEnPdpBusinessLogoMobile,
  },
  organizationStructuredData: {
    name: 'Cadeaubon.nl',
    url: 'https://www.cadeaubon.nl',
    logo: 'https://www.cadeaubon.nl/_next/static/media/logo.004b84eb.svg',
    description: 'Op Cadeaubon.nl vind je meer dan 200 verschillende cadeaubonnen. Voor 17 uur besteld, dezelfde ' +
        'dag verstuurd. Bestel dus snel en eenvoudig online!',
    contactPoint: {
      '@type': 'ContactPoint',
      contactType: 'Customer Service',
      email: 'klantenservice@cadeaubon.nl',
      telephone: '+31-030-227-16-47'
    },
    address: {
      '@type': 'PostalAddress',
      streetAddress: 'Schaverijstraat 30',
      addressLocality: 'Utrecht',
      postalCode: '3534 AS',
      addressCountry: {
        '@type': 'Country',
        name: 'NL',
      }
    },
    openingHours: ['Mo-Fr 09:00-17:30']
  }
};

const CBBE: VersionDependent = {
  logo: {
    src: CBBELogo,
  },
  logoV2: {
    src: CBBELogoV2,
  },
  footerClockIcon: {
    src: footerClockIcon,
  },
  footerLogo: {
    src: CBBEFooterLogo,
  },
  modalLogo: {
    src: CBBEModalLogo,
  },
  pdpFeaturedBlock: {
    src: CBBEPDPFeaturedBlock,
    link: 'https://www.cadeaubon.be/cadeaubonnen/cadeaubonbe-keuze-cadeaubon/',
  },
  pdpPromotionBlock: {
    src: promotionalBlock,
  },
  trustMarks: [],
  trustMarksTopbar: [{
    src: thuiswinkelTrustmark,
    link: 'https://www.thuiswinkel.org/leden-internationaal/cadeaubon-be/certificaat/',
    width: 120,
  }],
  notFoundImage: {
    src: CBNotFoundImage,
    width: 200,
  },
  headerDecoration: null,
  footerDecoration: null,
  faq: {
    src: fagImage,
  },
  doubler: {
    src: doublerImage,
  },
  doublerPageBg: {
    src: DoublerPageBG,
  },
  doublerHeroCardImage: {
    src: DoublerHeroCardImage,
  },
  paymentLogos: [
    PaymentLogo.Secure,
    PaymentLogo.Bancontact,
    PaymentLogo.Mastercard,
    PaymentLogo.Visa,
    PaymentLogo.Belfius,
    PaymentLogo.Kbccbc,
    PaymentLogo.Invoice,
  ],
  alternativeChoiceAllInOne: CBBEAlternativeChoiceAllInOne,
  pdpBusinessLogo: {
    [CONFIG.defaultLocale]: CBBEPdpBusinessLogo,
    'fr-be': CBBEFrPdpBusinessLogo,
  },
  mobilePdpBusinessLogo: {
    [CONFIG.defaultLocale]: CBBEPdpBusinessLogoMobile,
    'fr-be': CBBEFrPdpBusinessLogoMobile,
  },
  organizationStructuredData: {
    name: 'Cadeaubon.be',
    url: 'https://www.cadeaubon.be',
    logo: 'https://www.cadeaubon.be/_next/static/media/logo.729280dd.svg',
    description: 'Op Cadeaubon.be  vind je het grootste assortiment ' +
        'cadeaubonnen voor elke gelegenheid. Bestel op werkdagen vóór 17:00 en wij versturen jouw cadeaubon nog ' +
        'dezelfde dag. Snel, eenvoudig en altijd een perfect cadeau!',
    contactPoint: {
      '@type': 'ContactPoint',
      contactType: 'Customer Service',
      email: 'info@cadeaubon.be',
    },
    address: {
      '@type': 'PostalAddress',
      streetAddress: 'De Keyserlei 58-60/bus 19',
      addressLocality: 'Antwerpen',
      postalCode: '2018',
      addressCountry: {
        '@type': 'Country',
        name: 'BE',
      }
    }
  }
};

const GCUK: VersionDependent = {
  logo: {
    src: GCUKLogo,
  },
  logoV2: {
    src: GCUKLogoV2,
  },
  footerClockIcon: {
    src: footerClockIcon,
  },
  footerLogo: {
    src: GCUKFooterLogo,
  },
  modalLogo: {
    src: GCUKModalLogo,
  },
  pdpFeaturedBlock: {
    src: GCUKPDPFeaturedBlock,
    link: 'https://www.giftcard.co.uk/gift-cards/all-in-1-choice-gift-card/',
  },
  pdpPromotionBlock: {
    src: promotionalBlockPounds,
  },
  trustMarks: [
    {
      src: GCVALogo,
    },
    {
      src: IMAeuropeLogo,
    }
  ],
  trustMarksTopbar: [],
  notFoundImage: {
    src: CBNotFoundImage,
    width: 200,
  },
  headerDecoration: null,
  footerDecoration: null,
  faq: {
    src: fagImage,
  },
  doubler: {
    src: doublerImage,
  },
  doublerPageBg: {
    src: DoublerPageBG,
  },
  doublerHeroCardImage: {
    src: DoublerHeroCardImage,
  },
  paymentLogos: [
    PaymentLogo.Secure,
    PaymentLogo.Mastercard,
    PaymentLogo.Visa,
  ],
  alternativeChoiceAllInOne: GCUKAlternativeChoiceAllInOne,
  pdpBusinessLogo: {
    [CONFIG.defaultLocale]: GCUKPdpBusinessLogo,
  },
  mobilePdpBusinessLogo: {
    [CONFIG.defaultLocale]: GCUKPdpBusinessLogoMobile,
  },
  organizationStructuredData: {
    name: 'Giftcard.co.uk',
    url: 'https://www.giftcard.co.uk',
    logo: 'https://www.giftcard.co.uk/_next/static/media/logo.bc7cafdf.svg',
    description: 'At Giftcard.co.uk  you will find more than 300 different gift cards. Ordered before 5pm, ' +
        'shipped the same day. So order online quickly and easily!',
    contactPoint: {
      '@type': 'ContactPoint',
      contactType: 'Customer Service',
      email: 'support@giftcards.co.uk',
    },
    address: {
      '@type': 'PostalAddress',
      streetAddress: '71-75 Shelton Street',
      addressLocality: 'Covent Garden, London',
      postalCode: 'WC2H 9JQ',
      addressCountry: {
        '@type': 'Country',
        name: 'UK',
      }
    }
  }
};

const CK: VersionDependent = {
  logo: {
    src: CKLogo,
  },
  logoV2: {
    src: CKLogoV2,
  },
  footerClockIcon: {
    src: footerClockIcon,
  },
  footerLogo: {
    src: CKFooterLogo,
  },
  modalLogo: {
    src: CKModalLogo,
  },
  pdpFeaturedBlock: {
    src: CKPDPFeaturedBlock,
    link: 'https://www.cadeaukaart.nl/cadeaukaarten/cadeaukaartnl-keuze-cadeaukaart/',
  },
  pdpPromotionBlock: {
    src: promotionalBlock,
  },
  trustMarks: [],
  trustMarksTopbar: [],
  notFoundImage: {
    src: CKNotFoundImage,
    width: 450,
  },
  headerDecoration: null,
  footerDecoration: null,
  faq: {
    src: fagImage,
  },
  doubler: {
    src: doublerImage,
  },
  doublerPageBg: {
    src: CKDoublerPageBG,
  },
  doublerHeroCardImage: {
    src: CKDoublerHeroCardImage,
  },
  paymentLogos: [
    PaymentLogo.Secure,
    PaymentLogo.Ideal,
    PaymentLogo.Mastercard,
    PaymentLogo.Visa,
    PaymentLogo.Paypal,
  ],
  alternativeChoiceAllInOne: CKAlternativeChoiceAllInOne,
  pdpBusinessLogo: {
    [CONFIG.defaultLocale]: CKPdpBusinessLogo,
  },
  mobilePdpBusinessLogo: {
    [CONFIG.defaultLocale]: CKPdpBusinessLogoMobile,
  },
  organizationStructuredData: {
    name: 'Cadeaukaart.nl',
    url: 'https://www.cadeaukaart.nl',
    logo: 'https://www.cadeaukaart.nl/_next/static/media/logo.c3901459.svg',
    description: 'Meer dan 200 cadeaukaarten beschikbaar op Cadeaukaart kopen? De leukste cadeaukaarten vind je ' +
        'op cadeaukaart.nl! Bestel op werkdagen vóór 17:00 en profiteer van snelle verzending op dezelfde dag. Online ' +
        'bestellen was nog nooit zo makkelijk!',
    contactPoint: {
      '@type': 'ContactPoint',
      contactType: 'Customer Service',
      email: 'info@cadeaukaart.nl',
    },
    address: {
      '@type': 'PostalAddress',
      streetAddress: 'Ambachtsweg 6',
      addressLocality: 'Oosthuizen',
      postalCode: '1474 HW',
      addressCountry: {
        '@type': 'Country',
        name: 'NL',
      }
    }
  }
};

const GCSUK: VersionDependent = {
  logo: {
    src: GCSUKLogo,
  },
  logoV2: {
    src: GCSUKLogoV2,
  },
  footerClockIcon: {
    src: GCSUKFooterClockIcon,
  },
  footerLogo: {
    src: GCSUKFooterLogo,
  },
  modalLogo: {
    src: GCSUKModalLogo,
  },
  pdpFeaturedBlock: {
    src: GCSUKPDPFeaturedBlock,
    link: '/business/request-a-quote/',
  },
  pdpPromotionBlock: {
    src: promotionalBlockPounds,
  },
  trustMarks: [
    {
      src: GCVALogoWhite,
    },
    {
      src: IMAeuropeLogoWhite,
    }
  ],
  trustMarksTopbar: [],
  notFoundImage: {
    src: GCSUKNotFoundImage,
    width: 200,
  },
  headerDecoration: null,
  footerDecoration: null,

  faq: {
    src: GCSUKFagImage,
  },
  doubler: {
    src: GCSUKDoublerImage,
  },
  doublerPageBg: {
    src: DoublerPageBG,
  },
  doublerHeroCardImage: {
    src: DoublerHeroCardImage,
  },
  paymentLogos: [
    PaymentLogo.Secure,
    PaymentLogo.Mastercard,
    PaymentLogo.Visa,
    PaymentLogo.Amex,
  ],
  alternativeChoiceAllInOne: GCSUKAlternativeChoiceAllInOne,
  pdpBusinessLogo: {
    [CONFIG.defaultLocale]: GCSUKPdpBusinessLogo,
  },
  mobilePdpBusinessLogo: {
    [CONFIG.defaultLocale]: GCSUKPdpBusinessLogoMobile,
  },
  organizationStructuredData: {
    name: 'Giftcards.co.uk',
    url: 'https://www.giftcards.co.uk',
    logo: 'https://www.giftcards.co.uk/_next/static/media/logo.2855ea63.svg',
    description: 'At Giftcards.co.uk you will find more than 300 different gift cards. Ordered before 5pm, shipped ' +
        'the same day. So order online quickly and easily!',
    contactPoint: {
      '@type': 'ContactPoint',
      contactType: 'Customer Service',
      email: 'support@giftcard.co.uk',
    },
    address: {
      '@type': 'PostalAddress',
      streetAddress: '71-75 Shelton Street',
      addressLocality: 'Covent Garden, London',
      postalCode: 'WC2H 9JQ',
        addressCountry: {
          '@type': 'Country',
          name: 'UK',
        }
    }
  }
};

const CBDE: VersionDependent = {
  logo: {
    src: CBDELogo,
  },
  logoV2: {
    src: CBDELogoV2,
  },
  footerClockIcon: {
    src: footerClockIcon,
  },
  footerLogo: {
    src: CBDEFooterLogo,
  },
  modalLogo: {
    src: CBDEModalLogo,
  },
  pdpFeaturedBlock: {
    src: CBDEPDPFeaturedBlock,
    link: 'https://www.geschenkkarten.de/geschenkkarten/all-in-1-geschenkkarte/',
  },
  pdpPromotionBlock: {
    src: promotionalBlockCBDE,
  },
  trustMarks: [],
  trustMarksTopbar: [],
  notFoundImage: {
    src: CBNotFoundImage,
    width: 200,
  },
  headerDecoration: null,
  footerDecoration: null,
  faq: {
    src: fagImage,
  },
  doubler: {
    src: doublerImage,
  },
  doublerPageBg: {
    src: DoublerPageBG,
  },
  doublerHeroCardImage: {
    src: DoublerHeroCardImage,
  },
  paymentLogos: [
    PaymentLogo.Mastercard,
    PaymentLogo.Visa,
    PaymentLogo.Amex,
    PaymentLogo.Paypal,
  ],
  alternativeChoiceAllInOne: CBDEAlternativeChoiceAllInOne,
  pdpBusinessLogo: {
    [CONFIG.defaultLocale]: CBDEPdpBusinessLogo
  },
  mobilePdpBusinessLogo: {
    [CONFIG.defaultLocale]: CBDEPdpBusinessLogoMobile
  },
  organizationStructuredData: {
    name: 'Geschenkkarten.de',
    url: 'https://www.geschenkkarten.de',
    logo: 'https://www.geschenkkarten.de/_next/static/media/logo.e06ae420.svg',
    description: 'Entdecke über 150 verschiedene Geschenkkarten. Sofort digitale Geschenkgutscheine erhalten oder ' +
        'physische Karten nach Hause liefern lassen. Jetzt kaufen!',
    contactPoint: {
      '@type': 'ContactPoint',
      contactType: 'Customer Service',
      email: 'kontakt@geschenkkarten.de',
    },
    address: {
      '@type': 'PostalAddress',
      streetAddress: 'Ambachtsweg 6',
      addressLocality: 'Oosthuizen',
      postalCode: '1474 HW',
      addressCountry: {
        '@type': 'Country',
        name: 'NL',
      }
    }
  }
};

const CBIT: VersionDependent = {
  logo: {
    src: CBITLogo,
  },
  logoV2: {
    src: CBITLogoV2,
  },
  footerClockIcon: {
    src: footerClockIcon,
  },
  footerLogo: {
    src: CBITFooterLogo,
  },
  modalLogo: {
    src: CBITModalLogo,
  },
  pdpFeaturedBlock: {
    src: CBITPDPFeaturedBlock,
    link: 'https://www.cartaregalo.it/carte-regalo/gift-card-tutto-in-uno/',
  },
  pdpPromotionBlock: {
    src: promotionalBlock,
  },
  trustMarks: [],
  trustMarksTopbar: [],
  notFoundImage: {
    src: CBNotFoundImage,
    width: 200,
  },
  headerDecoration: null,
  footerDecoration: null,
  faq: {
    src: fagImage,
  },
  doubler: {
    src: doublerImage,
  },
  doublerPageBg: {
    src: DoublerPageBG,
  },
  doublerHeroCardImage: {
    src: DoublerHeroCardImage,
  },
  paymentLogos: [
    PaymentLogo.Mastercard,
    PaymentLogo.Visa,
    PaymentLogo.Amex,
    PaymentLogo.Paypal,
  ],
  alternativeChoiceAllInOne: CBITAlternativeChoiceAllInOne,
  pdpBusinessLogo: {
    [CONFIG.defaultLocale]: CBITPdpBusinessLogo,
  },
  mobilePdpBusinessLogo: {
    [CONFIG.defaultLocale]: CBITPdpBusinessLogoMobile,
  },
  organizationStructuredData: {
    name: 'Cartaregalo.it',
    url: 'https://www.cartaregalo.it',
    logo: 'https://www.cartaregalo.it/_next/static/media/logo.0ac458e8.svg',
    description: 'Scopri i migliori buoni regalo online su Gift card personalizzate | Buoni regalo online su ' +
        'Cartaregalo.it. Personalizza le gift card con un messaggio per gli amici o scegli le gift card aziendali ' +
        'per premiare il tuo team.',
    contactPoint: {
      '@type': 'ContactPoint',
      contactType: 'Customer Service',
      email: 'supporto@cartaregalo.it',
    },
    address: {
      '@type': 'PostalAddress',
      streetAddress: 'Ambachtsweg 6',
      addressLocality: 'Oosthuizen',
      postalCode: '1474 HW',
      addressCountry: {
        '@type': 'Country',
        name: 'NL',
      }
    }
  }
};

const CBIE: VersionDependent = {
  logo: {
    src: CBIELogo,
  },
  logoV2: {
    src: CBIELogoV2,
  },
  footerClockIcon: {
    src: footerClockIcon,
  },
  footerLogo: {
    src: CBIEFooterLogo,
  },
  modalLogo: {
    src: CBIEModalLogo,
  },
  pdpFeaturedBlock: {
    src: CBIEPDPFeaturedBlock,
    link: 'https://www.giftcard.ie/gift-cards/all-in-1-choice-gift-card/',
  },
  pdpPromotionBlock: {
    src: promotionalBlock,
  },
  trustMarks: [],
  trustMarksTopbar: [],
  notFoundImage: {
    src: CBNotFoundImage,
    width: 200,
  },
  headerDecoration: null,
  footerDecoration: null,
  faq: {
    src: fagImage,
  },
  doubler: {
    src: doublerImage,
  },
  doublerPageBg: {
    src: DoublerPageBG,
  },
  doublerHeroCardImage: {
    src: DoublerHeroCardImage,
  },
  paymentLogos: [
    PaymentLogo.Mastercard,
    PaymentLogo.Visa,
    PaymentLogo.Amex,
  ],
  alternativeChoiceAllInOne: CBIEAlternativeChoiceAllInOne,
  pdpBusinessLogo: {
    [CONFIG.defaultLocale]: CBIEPdpBusinessLogo,
  },
  mobilePdpBusinessLogo: {
    [CONFIG.defaultLocale]: CBIEPdpBusinessLogoMobile,
  },
  organizationStructuredData: {
    name: 'Giftcard.ie',
    url: 'https://www.giftcard.ie',
    logo: 'https://www.giftcard.ie/_next/static/media/logo.1d77e6f6.svg',
    description: 'At Giftcard.ie you will find more than 50 different gift cards. Ordered before 5pm, shipped the ' +
        'same day. So order online quickly and easily!',
    contactPoint: {
      '@type': 'ContactPoint',
      contactType: 'Customer Service',
      email: 'support@giftcard.ie',
    },
    address: {
      '@type': 'PostalAddress',
      streetAddress: 'Ambachtsweg 6',
      addressLocality: 'Oosthuizen',
      postalCode: '1474 HW',
      addressCountry: {
        '@type': 'Country',
        name: 'NL',
      }
    }
  }
};

const CBES: VersionDependent = {
  logo: {
    src: CBESLogo,
  },
  logoV2: {
    src: CBESLogoV2,
  },
  footerClockIcon: {
    src: footerClockIcon,
  },
  footerLogo: {
    src: CBESFooterLogo,
  },
  modalLogo: {
    src: CBESModalLogo,
  },
  pdpFeaturedBlock: {
    src: CBESPDPFeaturedBlock,
    link: 'https://www.tarjetaregalo.com/tarjetas-regalo/universal/',
  },
  pdpPromotionBlock: {
    src: promotionalBlock,
  },
  trustMarks: [],
  trustMarksTopbar: [],
  notFoundImage: {
    src: CBNotFoundImage,
    width: 200,
  },
  headerDecoration: null,
  footerDecoration: null,
  faq: {
    src: fagImage,
  },
  doubler: {
    src: doublerImage,
  },
  doublerPageBg: {
    src: DoublerPageBG,
  },
  doublerHeroCardImage: {
    src: DoublerHeroCardImage,
  },
  paymentLogos: [
    PaymentLogo.Mastercard,
    PaymentLogo.Visa,
    PaymentLogo.Amex,
  ],
  alternativeChoiceAllInOne: CBESAlternativeChoiceAllInOne,
  pdpBusinessLogo: {
    [CONFIG.defaultLocale]: CBESPdpBusinessLogo,
  },
  mobilePdpBusinessLogo: {
    [CONFIG.defaultLocale]: CBESPdpBusinessLogoMobile,
  },
  organizationStructuredData: {
    name: 'Tarjetaregalo.com',
    url: 'https://www.tarjetaregalo.com',
    logo: 'https://www.tarjetaregalo.com/_next/static/media/logo.dc3bbf3a.svg',
    description: '¡Tu #1 para tarjetas regalo! Encuentra el regalo perfecto en nuestra colección de más de 50 tarjetas ' +
        'regalo. Ofrecemos regalos corporativos cómodos, rápidos y personalizados, ideales para cualquier ocasión. ' +
        'Recibe tus tarjetas regalo digitales en minutos después de realizar tu pedido, y disfruta de una solución ' +
        'práctica y rápida.',
    contactPoint: {
      '@type': 'ContactPoint',
      contactType: 'Customer Service',
      email: 'asistencia@tarjetaregalo.com',
    },
    address: {
      '@type': 'PostalAddress',
      streetAddress: 'Ambachtsweg 6',
      addressLocality: 'Oosthuizen',
      postalCode: '1474 HW',
      addressCountry: {
        '@type': 'Country',
        name: 'NL',
      }
    }
  }
};

const GCSDE: VersionDependent = {
  logo: {
    src: GCSDELogo,
  },
  logoV2: {
    src: GCSDELogoV2,
  },
  footerClockIcon: {
    src: GCSDEFooterClockIcon,
  },
  footerLogo: {
    src: GCSDEFooterLogo,
  },
  modalLogo: {
    src: GCSDEModalLogo,
  },
  pdpFeaturedBlock: {
    src: GCSDEPDPFeaturedBlock,
    link: 'https://www.giftcard.de/unternehmen/',
  },
  pdpPromotionBlock: {
    src: promotionalBlockGCSDE,
  },
  trustMarks: [],
  trustMarksTopbar: [],
  notFoundImage: {
    src: GCSDENotFoundImage,
    width: 200,
  },
  headerDecoration: null,
  footerDecoration: null,

  faq: {
    src: GCSDEFagImage,
  },
  doubler: {
    src: GCSDEDoublerImage,
  },
  doublerPageBg: {
    src: DoublerPageBG,
  },
  doublerHeroCardImage: {
    src: DoublerHeroCardImage,
  },
  paymentLogos: [
    PaymentLogo.Mastercard,
    PaymentLogo.Visa,
    PaymentLogo.Amex,
    PaymentLogo.Paypal,
  ],
  alternativeChoiceAllInOne: GCSDEAlternativeChoiceAllInOne,
  pdpBusinessLogo: {
    [CONFIG.defaultLocale]: GCSDEPdpBusinessLogo,
  },
  mobilePdpBusinessLogo: {
    [CONFIG.defaultLocale]: GCSDEPdpBusinessLogoMobile,
  },
  organizationStructuredData: {
    name: 'Giftcard.de',
    url: 'https://www.giftcard.de',
    logo: 'https://www.giftcard.de/_next/static/media/logo.0c0a4832.svg',
    description: 'Wähle aus über 150 Geschenkkarten und Gutscheinen – jetzt online kaufen, als digitale Gift Card ' +
        'für sofortige Freude oder als physische Karte nach Hause.',
    contactPoint: {
      '@type': 'ContactPoint',
      contactType: 'Customer Service',
      email: 'kontakt@giftcard.de',
    },
    address: {
      '@type': 'PostalAddress',
      streetAddress: 'Ambachtsweg 6',
      addressLocality: 'Oosthuizen',
      postalCode: '1474 HW',
      addressCountry: {
        '@type': 'Country',
        name: 'NL',
      }
    }
  }
};

const GCSBE: VersionDependent = {
  logo: {
    src: GCSBELogo,
  },
  logoV2: {
    src: GCSBELogoV2,
  },
  footerClockIcon: {
    src: GCSBEFooterClockIcon,
  },
  footerLogo: {
    src: GCSBEFooterLogo,
  },
  modalLogo: {
    src: GCSBEModalLogo,
  },
  pdpFeaturedBlock: {
    src: GCSBEPDPFeaturedBlock,
    link: '/cadeaukaarten/giftcardsbe-keuze-cadeaukaart/',
  },
  pdpPromotionBlock: {
    src: promotionalBlock,
  },
  trustMarks: [],
  trustMarksTopbar: [],
  notFoundImage: {
    src: GCSDENotFoundImage,
    width: 200,
  },
  headerDecoration: null,
  footerDecoration: null,

  faq: {
    src: GCSBEFagImage,
  },
  doubler: {
    src: GCSBEDoublerImage,
  },
  doublerPageBg: {
    src: DoublerPageBG,
  },
  doublerHeroCardImage: {
    src: DoublerHeroCardImage,
  },
  paymentLogos: [
    PaymentLogo.Mastercard,
    PaymentLogo.Visa,
    PaymentLogo.Amex,
  ],
  alternativeChoiceAllInOne: GCSBEAlternativeChoiceAllInOne,
  pdpBusinessLogo: {
    [CONFIG.defaultLocale]: GCSBEPdpBusinessLogo,
  },
  mobilePdpBusinessLogo: {
    [CONFIG.defaultLocale]: GCSBEPdpBusinessLogoMobile,
  },
  organizationStructuredData: null,
};

const CBFR: VersionDependent = {
  logo: {
    src: CBFRLogo,
  },
  logoV2: {
    src: CBFRLogoV2,
  },
  footerClockIcon: {
    src: footerClockIcon,
  },
  footerLogo: {
    src: CBFRFooterLogo,
  },
  modalLogo: {
    src: CBFRModalLogo,
  },
  pdpFeaturedBlock: {
    src: CBFRPDPFeaturedBlock,
    link: 'https://www.cartecadeau.fr/cartes-cadeaux/carte-cadeau-multi-enseignes/',
  },
  pdpPromotionBlock: {
    src: promotionalBlock,
  },
  trustMarks: [],
  trustMarksTopbar: [],
  notFoundImage: {
    src: CBNotFoundImage,
    width: 200,
  },
  headerDecoration: null,
  footerDecoration: null,
  faq: {
    src: fagImage,
  },
  doubler: {
    src: doublerImage,
  },
  doublerPageBg: {
    src: DoublerPageBG,
  },
  doublerHeroCardImage: {
    src: DoublerHeroCardImage,
  },
  paymentLogos: [
    PaymentLogo.Mastercard,
    PaymentLogo.Visa,
    PaymentLogo.Amex,
    PaymentLogo.CarteBancaire,
    PaymentLogo.Paypal,
  ],
  alternativeChoiceAllInOne: CBFRAlternativeChoiceAllInOne,
  pdpBusinessLogo: {
    [CONFIG.defaultLocale]: CBFRPdpBusinessLogo,
  },
  mobilePdpBusinessLogo: {
    [CONFIG.defaultLocale]: CBFRPdpBusinessLogoMobile,
  },
  organizationStructuredData: {
    name: 'Cartecadeau.fr',
    url: 'https://www.cartecadeau.fr',
    logo: 'https://www.cartecadeau.fr/_next/static/media/logo.0e7c9fc4.svg',
    description: 'Sur Cartecadeau.fr vous trouverez plus de 150 cartes cadeaux différentes. Commandées avant 17h, elles ' +
        'sont expédiées le jour même. Alors commandez en ligne rapidement et facilement !',
    contactPoint: {
      '@type': 'ContactPoint',
      contactType: 'Customer Service',
      email: 'support@cartecadeau.fr',
    },
    address: {
      '@type': 'PostalAddress',
      streetAddress: 'Ambachtsweg 6',
      addressLocality: 'Oosthuizen',
      postalCode: '1474 HW',
      addressCountry: {
        '@type': 'Country',
        name: 'NL',
      }
    }
  }
};
const GCSNL: VersionDependent = {
  logo: {
    src: GCSNLLogo,
  },
  logoV2: {
    src: GCSNLLogoV2,
  },
  footerClockIcon: {
    src: GCSNLFooterClockIcon,
  },
  footerLogo: {
    src: GCSNLFooterLogo,
  },
  modalLogo: {
    src: GCSNLModalLogo,
  },
  pdpFeaturedBlock: {
    src: GCSNLPDPFeaturedBlock,
    link: '/cadeaukaarten/giftcardsnl-keuze-cadeaukaart-paars/',
  },
  pdpPromotionBlock: {
    src: promotionalBlock,
  },
  trustMarks: [],
  trustMarksTopbar: [],
  notFoundImage: {
    src: GCSNLNotFoundImage,
    width: 200,
  },
  headerDecoration: null,
  footerDecoration: null,
  faq: {
    src: GCSNLFagImage,
  },
  doubler: {
    src: GCSNLDoublerImage,
  },
  doublerPageBg: {
    src: DoublerPageBG,
  },
  doublerHeroCardImage: {
    src: DoublerHeroCardImage,
  },
  paymentLogos: [
    PaymentLogo.Secure,
    PaymentLogo.Ideal,
    PaymentLogo.Mastercard,
    PaymentLogo.Visa,
    PaymentLogo.Invoice,
  ],
  alternativeChoiceAllInOne: GCSNLAlternativeChoiceAllInOne,
  pdpBusinessLogo: {
    [CONFIG.defaultLocale]: GCSNLPdpBusinessLogo,
  },
  mobilePdpBusinessLogo: {
    [CONFIG.defaultLocale]: GCSNLPdpBusinessLogoMobile,
  },
  organizationStructuredData: {
    name: 'Giftcards.nl',
    url: 'https://www.giftcards.nl',
    logo: 'https://www.giftcards.nl/_next/static/media/logo.454fe3ab.svg',
    description: 'Ontdek een uitgebreid aanbod van meer dan 200 cadeaukaarten op Cadeaukaart kopen doe je op ' +
        'Giftcards.nl. Bestel op werkdagen vóór 17:00 en wij versturen jouw cadeaukaart nog dezelfde dag. Kies ' +
        'eenvoudig en snel online!',
    contactPoint: {
      '@type': 'ContactPoint',
      contactType: 'Customer Service',
      email: 'info@giftcards.nl',
    },
    address: {
      '@type': 'PostalAddress',
      streetAddress: 'Ambachtsweg 6',
      addressLocality: 'Oosthuizen',
      postalCode: '1474 HW',
      addressCountry: {
        '@type': 'Country',
        name: 'NL',
      }
    }
  }
};

const GCSFR: VersionDependent = {
  logo: {
    src: GCSFRLogo,
  },
  logoV2: {
    src: GCSFRLogoV2,
  },
  footerClockIcon: {
    src: GCSFRFooterClockIcon,
  },
  footerLogo: {
    src: GCSFRFooterLogo,
  },
  modalLogo: {
    src: GCSFRModalLogo,
  },
  pdpFeaturedBlock: {
    src: GCSFRPDPFeaturedBlock,
    link: 'https://www.giftcards.fr/cartes-cadeaux/carte-cadeau-multi-enseignes/',
  },
  pdpPromotionBlock: {
    src: promotionalBlock,
  },
  trustMarks: [],
  trustMarksTopbar: [],
  notFoundImage: {
    src: GCSFRNotFoundImage,
    width: 200,
  },
  headerDecoration: null,
  footerDecoration: null,

  faq: {
    src: GCSFRFagImage,
  },
  doubler: {
    src: GCSFRDoublerImage,
  },
  doublerPageBg: {
    src: DoublerPageBG,
  },
  doublerHeroCardImage: {
    src: DoublerHeroCardImage,
  },
  paymentLogos: [
    PaymentLogo.Mastercard,
    PaymentLogo.Visa,
    PaymentLogo.Amex,
    PaymentLogo.CarteBancaire,
    PaymentLogo.Paypal,
  ],
  alternativeChoiceAllInOne: GCSFRAlternativeChoiceAllInOne,
  pdpBusinessLogo: {
    [CONFIG.defaultLocale]: GCSFRPdpBusinessLogo,
  },
  mobilePdpBusinessLogo: {
    [CONFIG.defaultLocale]: GCSFRPdpBusinessLogoMobile,
  },
  organizationStructuredData: {
    name: 'Giftcards.fr',
    url: 'https://www.giftcards.fr',
    logo: 'https://www.giftcards.fr/_next/static/media/logo.3acf24c7.svg',
    description: "Votre numéro 1 en cartes cadeaux! Découvrez notre large sélection de plus de 160 cartes cadeaux pour" +
        "trouver le cadeau idéal. Offrez des solutions pratiques, rapides et personnalisées, que ce soit pour des" +
        "cadeaux d'entreprise ou des occasions spéciales. Recevez vos e-cartes cadeaux en quelques minutes après " +
        "commande et profitez de la livraison rapide de cartes cadeaux physiques directement chez vous.",
    contactPoint: {
      '@type': 'ContactPoint',
      contactType: 'Customer Service',
      email: 'support@giftcards.fr',
    },
    address: {
      '@type': 'PostalAddress',
      streetAddress: 'Ambachtsweg 6',
      addressLocality: 'Oosthuizen',
      postalCode: '1474 HW',
      addressCountry: {
        '@type': 'Country',
        name: 'NL',
      }
    }
  }
};

const GCSIT: VersionDependent = {
  logo: {
    src: GCSITLogo,
  },
  logoV2: {
    src: GCSITLogoV2,
  },
  footerClockIcon: {
    src: footerClockIcon,
  },
  footerLogo: {
    src: GCSITFooterLogo,
  },
  modalLogo: {
    src: GCSITModalLogo,
  },
  pdpFeaturedBlock: {
    src: GCSITPDPFeaturedBlock,
    link: 'https://www.giftcards.it/gift-cards/gift-card-tutto-in-uno/',
  },
  pdpPromotionBlock: {
    src: promotionalBlock,
  },
  trustMarks: [],
  trustMarksTopbar: [],
  notFoundImage: {
    src: GCSDENotFoundImage,
    width: 200,
  },
  headerDecoration: null,
  footerDecoration: null,

  faq: {
    src: GCSDEFagImage,
  },
  doubler: {
    src: GCSDEDoublerImage,
  },
  doublerPageBg: {
    src: DoublerPageBG,
  },
  doublerHeroCardImage: {
    src: DoublerHeroCardImage,
  },
  paymentLogos: [
    PaymentLogo.Mastercard,
    PaymentLogo.Visa,
    PaymentLogo.Amex,
    PaymentLogo.Paypal,
  ],
  alternativeChoiceAllInOne: GCSITAlternativeChoiceAllInOne,
  pdpBusinessLogo: {
    [CONFIG.defaultLocale]: GCSITPdpBusinessLogo,
  },
  mobilePdpBusinessLogo: {
    [CONFIG.defaultLocale]: GCSITPdpBusinessLogoMobile,
  },
  organizationStructuredData: {
    name: 'Giftcards.it',
    url: 'https://www.giftcards.it',
    logo: 'https://www.giftcards.it/_next/static/media/logo.de5df8e3.svg',
    description: 'Trova le migliori gift card online su Gift card online | Personalizza i buoni regalo su ' +
        'Giftcards.it. Personalizza ogni buono regalo per renderlo unico e perfetto per qualsiasi occasione.',
    contactPoint: {
      '@type': 'ContactPoint',
      contactType: 'Customer Service',
      email: 'supporto@giftcards.it',
    },
    address: {
      '@type': 'PostalAddress',
      streetAddress: 'Ambachtsweg 6',
      addressLocality: 'Oosthuizen',
      postalCode: '1474 HW',
      addressCountry: {
        '@type': 'Country',
        name: 'NL',
      }
    }
  }
};

const GCSIE: VersionDependent = {
  logo: {
    src: GCSIELogo,
  },
  logoV2: {
    src: GCSIELogoV2,
  },
  footerClockIcon: {
    src: footerClockIcon,
  },
  footerLogo: {
    src: GCSIEFooterLogo,
  },
  modalLogo: {
    src: GCSIEModalLogo,
  },
  pdpFeaturedBlock: {
    src: GCSIEPDPFeaturedBlock,
    link: 'https://www.giftcards.ie/gift-cards/All-in-1-choice-gift-card/',
  },
  pdpPromotionBlock: {
    src: promotionalBlock,
  },
  trustMarks: [],
  trustMarksTopbar: [],
  notFoundImage: {
    src: GCSDENotFoundImage,
    width: 200,
  },
  headerDecoration: null,
  footerDecoration: null,

  faq: {
    src: GCSDEFagImage,
  },
  doubler: {
    src: GCSDEDoublerImage,
  },
  doublerPageBg: {
    src: DoublerPageBG,
  },
  doublerHeroCardImage: {
    src: DoublerHeroCardImage,
  },
  paymentLogos: [
    PaymentLogo.Mastercard,
    PaymentLogo.Visa,
    PaymentLogo.Amex,
  ],
  alternativeChoiceAllInOne: GCSIEAlternativeChoiceAllInOne,
  pdpBusinessLogo: {
    [CONFIG.defaultLocale]: GCSIEPdpBusinessLogo,
  },
  mobilePdpBusinessLogo: {
    [CONFIG.defaultLocale]: GCSIEPdpBusinessLogoMobile,
  },
  organizationStructuredData: {
    name: 'Giftcards.ie',
    url: 'https://www.giftcards.ie',
    logo: 'https://www.giftcards.ie/_next/static/media/logo.276ab87e.svg',
    description: 'At Giftcards.ie you will find more than 50 different gift cards. Ordered before 5pm, shipped the ' +
        'same day. So order online quickly and easily!',
    contactPoint: {
      '@type': 'ContactPoint',
      contactType: 'Customer Service',
      email: 'support@giftcards.ie',
    },
    address: {
      '@type': 'PostalAddress',
      streetAddress: 'Ambachtsweg 6',
      addressLocality: 'Oosthuizen',
      postalCode: '1474 HW',
      addressCountry: {
        '@type': 'Country',
        name: 'NL',
      }
    }
  }
};

const CBAT: VersionDependent = {
  logo: {
    src: CBATLogo,
  },
  logoV2: {
    src: CBATLogoV2,
  },
  footerClockIcon: {
    src: footerClockIcon,
  },
  footerLogo: {
    src: CBATFooterLogo,
  },
  modalLogo: {
    src: CBATModalLogo,
  },
  pdpFeaturedBlock: {
    src: CBATPDPFeaturedBlock,
    link: 'https://www.geschenkkarten.at/geschenkkarten/all-in-1-geschenkkarte/',
  },
  pdpPromotionBlock: {
    src: promotionalBlock,
  },
  trustMarks: [],
  trustMarksTopbar: [],
  notFoundImage: {
    src: CBATNotFoundImage,
    width: 200,
  },
  headerDecoration: null,
  footerDecoration: null,
  faq: {
    src: fagImage,
  },
  doubler: {
    src: doublerImage,
  },
  doublerPageBg: {
    src: DoublerPageBG,
  },
  doublerHeroCardImage: {
    src: DoublerHeroCardImage,
  },
  paymentLogos: [
    PaymentLogo.Mastercard,
    PaymentLogo.Visa,
    PaymentLogo.Amex,
    PaymentLogo.Paypal,
    PaymentLogo.AdyenEPS,
  ],
  alternativeChoiceAllInOne: CBATAlternativeChoiceAllInOne,
  pdpBusinessLogo: {
    [CONFIG.defaultLocale]: CBATPdpBusinessLogo,
  },
  mobilePdpBusinessLogo: {
    [CONFIG.defaultLocale]: CBATPdpBusinessLogoMobile,
  },
  organizationStructuredData: {
    name: 'Geschenkkarten.at',
    url: 'https://www.geschenkkarten.at',
    logo: 'https://www.geschenkkarten.at/_next/static/media/logo.0eeabca6.svg',
    description: 'Wähle aus über 60 Geschenkkarten. Erhalte digitale Gutscheine sofort oder bestelle physische ' +
        'Karten bequem nach Hause. Jetzt shoppen bei Geschenkkarten.at!',
    contactPoint: {
      '@type': 'ContactPoint',
      contactType: 'Customer Service',
      email: 'kontakt@geschenkkarten.at',
    },
    address: {
      '@type': 'PostalAddress',
      streetAddress: 'Ambachtsweg 6',
      addressLocality: 'Oosthuizen',
      postalCode: '1474 HW',
      addressCountry: {
        '@type': 'Country',
        name: 'NL',
      }
    }
  }
};

const GCSAT: VersionDependent = {
  logo: {
    src: GCSATLogo,
  },
  logoV2: {
    src: GCSATLogoV2,
  },
  footerClockIcon: {
    src: GCSATFooterClockIcon,
  },
  footerLogo: {
    src: GCSATFooterLogo,
  },
  modalLogo: {
    src: GCSATModalLogo,
  },
  pdpFeaturedBlock: {
    src: GCSATPDPFeaturedBlock,
    link: 'https://www.giftcards.at/geschenkkarten/all-in-1-geschenkkarte/',
  },
  pdpPromotionBlock: {
    src: promotionalBlock,
  },
  trustMarks: [],
  trustMarksTopbar: [],
  notFoundImage: {
    src: GCSATNotFoundImage,
    width: 200,
  },
  headerDecoration: null,
  footerDecoration: null,

  faq: {
    src: GCSATFagImage,
  },
  doubler: {
    src: GCSATDoublerImage,
  },
  doublerPageBg: {
    src: DoublerPageBG,
  },
  doublerHeroCardImage: {
    src: DoublerHeroCardImage,
  },
  paymentLogos: [
    PaymentLogo.Mastercard,
    PaymentLogo.Visa,
    PaymentLogo.Amex,
    PaymentLogo.Paypal,
    PaymentLogo.AdyenEPS,
  ],
  alternativeChoiceAllInOne: GCSATAlternativeChoiceAllInOne,
  pdpBusinessLogo: {
    [CONFIG.defaultLocale]: GCSATPdpBusinessLogo,
  },
  mobilePdpBusinessLogo: {
    [CONFIG.defaultLocale]: GCSATPdpBusinessLogoMobile,
  },
  organizationStructuredData: {
    name: 'Giftcards.at',
    url: 'https://www.giftcards.at',
    logo: 'https://www.giftcards.at/_next/static/media/logo.81884694.svg',
    description: 'OWähle das ideale Geschenk aus +60 Geschenkkarten. Erhalte sofort digitale Gutscheine oder ' +
        'physische Gift Cards nach Hause geliefert. Jetzt online shoppen!',
    contactPoint: {
      '@type': 'ContactPoint',
      contactType: 'Customer Service',
      email: 'kontakt@giftcards.at',
    },
    address: {
      '@type': 'PostalAddress',
      streetAddress: 'Ambachtsweg 6',
      addressLocality: 'Oosthuizen',
      postalCode: '1474 HW',
      addressCountry: {
        '@type': 'Country',
        name: 'NL',
      }
    }
  }
};

const CBPL: VersionDependent = {
  logo: {
    src: CBPLLogo,
  },
  logoV2: {
    src: CBPLLogoV2,
  },
  footerClockIcon: {
    src: footerClockIcon,
  },
  footerLogo: {
    src: CBPLFooterLogo,
  },
  modalLogo: {
    src: CBPLModalLogo,
  },
  pdpFeaturedBlock: {
    src: CBPLPDPFeaturedBlock,
    link: 'https://www.kartapodarunkowa.pl/karty-podarunkowe/uniwersalna-karta-podarunkowa/',
  },
  pdpPromotionBlock: {
    src: promotionalBlock,
  },
  trustMarks: [],
  trustMarksTopbar: [],
  notFoundImage: {
    src: CBNotFoundImage,
    width: 200,
  },
  headerDecoration: null,
  footerDecoration: null,
  faq: {
    src: fagImage,
  },
  doubler: {
    src: doublerImage,
  },
  doublerPageBg: {
    src: DoublerPageBG,
  },
  doublerHeroCardImage: {
    src: DoublerHeroCardImage,
  },
  paymentLogos: [
    PaymentLogo.Mastercard,
    PaymentLogo.Visa,
    PaymentLogo.Amex
  ],
  alternativeChoiceAllInOne: CBPLAlternativeChoiceAllInOne,
  pdpBusinessLogo: {
    [CONFIG.defaultLocale]: CBPLPdpBusinessLogo,
    'en-nl': CBEnPdpBusinessLogo,
  },
  mobilePdpBusinessLogo: {
    [CONFIG.defaultLocale]: CBPLPdpBusinessLogoMobile,
    'en-nl': CBEnPdpBusinessLogoMobile,
  },
  organizationStructuredData: {
    name: 'Kartapodarunkowa.pl',
    url: 'https://www.kartapodarunkowa.pl',
    logo: 'https://www.kartapodarunkowa.pl/_next/static/media/logo.fb423872.svg',
    description: 'Twoja #1 dla kart podarunkowych! Wybierz idealny prezent z naszej kolekcji ponad 30 kart ' +
        'podarunkowych. Otrzymaj e-kartę podarunkową online w ciągu kilku minut od zamówienia! Doskonały prezent ' +
        'biznesowy – praktyczny, szybki i spersonalizowany! Firmowe karty podarunkowe idealne na każdą okazję, ' +
        'dostępne w przedziale od 50 zł do 2000 zł.',
    contactPoint: {
      '@type': 'ContactPoint',
      contactType: 'Customer Service',
      email: 'wsparcie@kartapodarunkowa.pl',
    },
    address: {
      '@type': 'PostalAddress',
      streetAddress: 'Ambachtsweg 6',
      addressLocality: 'Oosthuizen',
      postalCode: '1474 HW',
      addressCountry: {
        '@type': 'Country',
        name: 'NL',
      }
    }
  }
};

const CKFR: VersionDependent = {
  logo: {
    src: CKFRLogo,
  },
  logoV2: {
    src: CKFRLogoV2,
  },
  footerClockIcon: {
    src: footerClockIcon,
  },
  footerLogo: {
    src: CKFRFooterLogo,
  },
  modalLogo: {
    src: CKFRModalLogo,
  },
  pdpFeaturedBlock: {
    src: CKFRPDPFeaturedBlock,
    link: 'https://www.cartescadeaux.com/carte-cadeau/multi-enseignes/',
  },
  pdpPromotionBlock: {
    src: promotionalBlock,
  },
  trustMarks: [],
  trustMarksTopbar: [],
  notFoundImage: {
    src: CKNotFoundImage,
    width: 450,
  },
  headerDecoration: null,
  footerDecoration: null,
  faq: {
    src: fagImage,
  },
  doubler: {
    src: doublerImage,
  },
  doublerPageBg: {
    src: CKDoublerPageBG,
  },
  doublerHeroCardImage: {
    src: CKDoublerHeroCardImage,
  },
  paymentLogos: [
    PaymentLogo.Mastercard,
    PaymentLogo.Visa,
    PaymentLogo.Amex,
  ],
  alternativeChoiceAllInOne: CKFRAlternativeChoiceAllInOne,
  pdpBusinessLogo: {
    [CONFIG.defaultLocale]: CKFRPdpBusinessLogo,
  },
  mobilePdpBusinessLogo: {
    [CONFIG.defaultLocale]: CKFRPdpBusinessLogoMobile,
  },
  organizationStructuredData: {
    name: 'Cartescadeaux.com',
    url: 'https://www.cartescadeaux.com',
    logo: 'https://www.cartescadeaux.com/_next/static/media/logo.f76d99e7.svg',
    description: 'Choisissez parmi plus de 70 cartes cadeaux et trouvez celle qui correspond parfaitement à vos ' +
        'besoins. Offrir une carte cadeau, c’est offrir un cadeau flexible et idéal, que ce soit pour des occasions ' +
        'personnelles ou professionnelles. Recevez votre carte cadeau imprimable en quelques minutes seulement et ' +
        'profitez d’une solution simple et rapide!',
    contactPoint: {
      '@type': 'ContactPoint',
      contactType: 'Customer Service',
      email: 'support@cartescadeaux.com',
    },
    address: {
      '@type': 'PostalAddress',
      streetAddress: 'Ambachtsweg 6',
      addressLocality: 'Oosthuizen',
      postalCode: '1474 HW',
      addressCountry: {
        '@type': 'Country',
        name: 'NL',
      }
    }
  }
};

export const versions: Versions = {
  CB,
  CK,
  CBBE,
  GCUK,
  GCSUK,
  CBDE,
  CBIT,
  CBIE,
  CBES,
  GCSDE,
  GCSBE,
  CBFR,
  GCSFR,
  GCSNL,
  GCSIT,
  GCSIE,
  CBAT,
  GCSAT,
  CKFR,
  CBPL,
  default: CB,
  CBNZ,
  CBSE,
  CBMX,
  CBDK,
  CBNO,
  CKUK,
  CBAU,
  CBBR,
  GCSPT,
};

export const versionDependent: VersionDependent = versions[CONFIG.applicationBuild || 'default'];
